module.exports = __webpack_public_path__ + "static/media/hero-order-en.770d4b6e.png";